import type { components } from "@api/schema";
import type { BoardVisit } from "@board/boardVisit";

export type Lane = components["schemas"]["VisitFlow"];
export type Position = components["schemas"]["VisitPosition"];

export const EXAM_POSITIONS = [
  "scheduled",
  "checked_in",
  "in_room",
  "with_dvm",
  "treatment",
  "ready_for_checkout",
  "checked_out",
] as const satisfies readonly Position[];

export const DROPOFF_POSITIONS = [
  "scheduled",
  "dropped_off",
  "in_treatment",
  "ready_for_pickup",
  "picked_up",
] as const satisfies readonly Position[];

export const POSITION_LABELS: Record<Position, string> = {
  scheduled: "Scheduled",
  checked_in: "Checked in",
  in_room: "In room",
  with_dvm: "With DVM",
  treatment: "Treatment",
  ready_for_checkout: "Ready for checkout",
  checked_out: "Checked out",
  dropped_off: "Dropped off",
  in_treatment: "In treatment",
  ready_for_pickup: "Ready for pickup",
  picked_up: "Picked up",
};

export const TERMINAL_POSITIONS: ReadonlySet<Position> = new Set([
  "checked_out",
  "picked_up",
]);

const minutesBehind = (
  visit: BoardVisit,
  position: Position,
  now: number,
): number | null => {
  if (TERMINAL_POSITIONS.has(position)) return null;
  const anchor =
    position === "scheduled" ? visit.scheduledStart : visit.scheduledEnd;
  if (!anchor) return null;
  const minutes = Math.floor((now - Date.parse(anchor)) / 60_000);
  return minutes > 0 ? minutes : null;
};

interface BoardPlacement {
  lane: Lane;
  position: Position;
  behindMinutes: number | null;
}

export const placeOnBoard = (
  visit: BoardVisit,
  now: number,
): BoardPlacement => ({
  lane: visit.flow,
  position: visit.position,
  behindMinutes: minutesBehind(visit, visit.position, now),
});
